<template>
    <kt-panel>
        <kt-heading class="px-3" level="1">
            {{$t('label.transfer_between_banks')}}
        </kt-heading>
        <div class="mx-2 my-4 p-3">
            <form id="submit_form" @submit.prevent="transfer">
                <kt-row>
                    <kt-col sm="12" xs="12" md="6" lg="6" xl="6" class="p-2">
                        <label for="from">{{ $t('label.source_account_number') }}</label>
                        <select
                            id="from"
                            name="from"
                            v-model="from"
                            class="form-control kt-selectpicker"
                        >
                            <option v-for="(item, index) in bank_accounts"
                                    v-if="checkBankName(item)"

                                    :key="index" :value="item.number">
                                {{ `${item.number} - ${item.fa_name} (${item.bank_fa_name})` }}
                            </option>

                        </select>
                    </kt-col>
                    <kt-col sm="12" xs="12" md="6" lg="6" xl="6" class="p-2">
                        <label for="to">{{ $t('wallets.label.destination_deposit') }}</label>
                        <select
                            id="to"
                            name="to"
                            v-model="to"
                            class="form-control kt-selectpicker"
                        >
                            <option v-for="(item, index) in bank_accounts"
                                    :key="index" :value="item.iban">
                                {{ `${item.number} - ${item.fa_name} (${item.bank_fa_name})` }}
                            </option>

                        </select>
                    </kt-col>
                    <kt-col sm="12" xs="12" md="6" lg="6" xl="6" class="p-2">
                        <label for="to">{{ $t('label.amount_rial') }}</label>
                        <amount-input
                            item_id="amount"
                            item_name="amount"
                            :item="item"
                        ></amount-input>
                    </kt-col>
                </kt-row>

                <kt-row class="mt-4">
                    <button id="submit_btn" class="btn btn-success">{{ $t('btn.transfer_amount') }}</button>
                </kt-row>
            </form>
        </div>
    </kt-panel>
</template>

<script>
import {walletService} from "@/common/api.service";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import AmountInput from "@/components/custom-elements/amount-input";
import Button from "@/components/elements/button.vue";
import {KTApp} from '@/plugins/core/app'

export default {
    props: {
        fetch_starshop: {
            default: false,
            type: Boolean
        },
    },
    name: "Transfer",
    components: {Button, AmountInput},
    data() {
        return {
            from: null,
            to: null,
            item: {amount: 0},
            bank_accounts: []
        }
    },

    async mounted() {
        const avilableBankAccounts = this.fetch_starshop
            ? walletService.getStarShopAllWalletBankAccountNumbers
            : walletService.getAllWalletBankAccountNumbers;

        await avilableBankAccounts().then(res => {
            this.bank_accounts = res.data;
            this.afterDispatch();
        });

        this.afterDispatch();
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        checkBankName(bank) {
            return bank.bank_fa_name === 'صادرات' || bank.bank_fa_name === 'آینده' || bank.bank_fa_name === 'سامان';
        },

        transfer(event) {
            let form = $(event.target);
            let btn = $("#submit_btn");

            form.validate({
                rules: {
                    from: {
                        required: true
                    },
                    to: {
                        required: true
                    },
                    amount: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                return false;
            }

            let data = {
                from: this.from,
                to: this.to,
                amount: this.item.amount,
            }

            KTApp.progress(btn)

            const transfer = this.fetch_starshop
                ? walletService.transferStarShop
                : walletService.transfer;

            transfer(data)
                .then(({data}) => {
                    this.toastr.success(data.message)

                }).catch(({response}) => {
                    this.toastr.error(response.data.message)

            }).finally(() => {
                KTApp.unprogress(btn)
            })

        },
    },


    computed: {},
}
</script>

<style scoped>

</style>